<template>
  <div class="hello">
    <navbar></navbar>
    This URL is in use for Andrea van Leerdam's PhD research project, 'Woodcuts as reading aids: Illustrations and knowledge transfer in printed books in Dutch on the natural world, c. 1480 - c. 1550', at Utrecht University, the Netherlands.
    More information: <a href="http://www.uu.nl/staff/aevanleerdam" target="_blank">www.uu.nl/staff/aevanleerdam</a>
  </div>
</template>

<script>

import navbar from './navbar.vue';

export default {
  name: 'hello',
  data () {
    return {

    }
  },
  components: {
    'navbar': navbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?694e7398